import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CPCAnalysis = ({ leaders }) => {
  if (!leaders || leaders.length === 0) return null;

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl sm:rounded-3xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-xl">
          <SafeIcon icon={FiIcons.FiDollarSign} className="w-5 h-5" />
        </div>
        <div>
          <h3 className="text-[11px] sm:text-sm font-black uppercase tracking-widest text-slate-800 dark:text-slate-200">High-Value Keywords (CPC)</h3>
          <p className="text-[9px] sm:text-[10px] text-slate-400 font-bold uppercase tracking-wider">Top Monetization Opportunities</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {leaders.map((kw, i) => (
          <div key={i} className="p-4 bg-emerald-50/30 dark:bg-emerald-900/10 border border-emerald-100/50 dark:border-emerald-900/20 rounded-2xl hover:scale-[1.02] transition-transform">
            <div className="flex justify-between items-start mb-2">
              <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">CPC Leader</span>
              <span className="text-sm font-black text-emerald-600">${kw.cpc.toFixed(2)}</span>
            </div>
            <h4 className="text-xs sm:text-sm font-black text-slate-800 dark:text-slate-100 mb-2 truncate" title={kw.keyword}>
              {kw.keyword}
            </h4>
            <div className="flex items-center justify-between text-[10px] font-bold text-slate-400 uppercase tracking-tighter">
              <span>Vol: {kw.volume.toLocaleString()}</span>
              <span className="text-emerald-500/80">Value: ${(kw.volume * kw.cpc).toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CPCAnalysis;